import React from "react";
export const getEnigooTurnstileTicketTicketType = (ticketType)=>{
    if(!ticketType){
        return "";
    }
    switch (ticketType){
        case 0:
            return "Servisní karta";
        case 1:
            return "Běžná vstupenka";
        case 2:
            return "Permanentka s kreditem";
        default:
            return ""
    }
}

export const getEnigooTurnstileTicketType = (type)=>{
    if(!type) return "";
    switch (type){
        case 1:
            return "Dětská vstupenka";
        case 2:
            return "Zlevněná vstupenka";
        default:
            return "";
    }
}

export const TURNSTILE_TYPES = [
    {id:0,value:"Vguang IP",description:"QR/NFC čtečka VGUANG IP -> turnikety TimeData, TSS, komunikuje pomocí TCP (9876)"},
    {id:1,value:"RFID čtečka Papouch", description: "RFID čtečka od výrobce Papouch (otevírání dveří CHKJ), komunikuje pomocí TCP (9876)"},
    {id:2,value:"ELVIS", description: "Elvis turnikety, komunikuje pomocí TCP (9876) nebo UDP (9877)"},
    {id:3,value:"ELVIS tlačítko", description: "Elvis odchodové tlačítko, komunikuje pomocí TCP (9876) nebo UDP (9877)"},
    {id:4,value:"Ticket validator (API)", description: "Ticket Validator, komunikuje přes API"},
    {id:5,value:"DSN Turniket (Přes převodník WaveShare)",description: "DSN turniket -> počítání protočení, připojeno přes waveshare RS485->RJ45 převodník -> turnikety TimeData, , komunikuje pomocí TCP (9876)"},
    {id:6, value: "ENIGOO čtečka", description: "Čtečka ENIGOO, komunikující přes API"},
    {id:7, value: "ENIGOO rozpoznávání obličeje", description: "Čtečka ENIGOO s rozpoznáváním obličeje komunikující přes API"},
    {id: 8, value: "Ticket validator (socket)",description: "Ticket validator, komunikuje přes TCP (9878)"}
]

export const getTurnstileTypesToSelect = () => {
    let types = [];
    TURNSTILE_TYPES.forEach(turn => {
        types.push({value:turn.id,label:turn.value});
    })
    return types;
}

export const getEnigooTurnstileType = (type)=>{
    let typeStr = null;
    TURNSTILE_TYPES.forEach((t)=>{
        if(t.id===type){
            typeStr = t.value;
        }
    })
    if(!typeStr){
        return TURNSTILE_TYPES[0].value;
    }
    return typeStr;
}

export const getEnigooTurnstileEntryType = (type,turnstileType)=>{
    if(turnstileType === 6){
        return "-"
    }
    switch (type){
        case 0:
            return <div className={"text-red-400 font-bold"}>Východ</div>
        case 1:
            return <div className={"text-green-500 font-bold"}>Vchod</div>
        case 2:
            return <div className={"text-blue-400 font-bold"}>V areálu</div>
        default:
            return "-"
    }
}
